// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290634/js/" + chunkId + "." + {"44":"8f1c74aa","225":"5217214b","481":"ef93391a","486":"13294923","770":"cc35d646"}[chunkId] + ".0.30974549371690074.chunk.js";
};